exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.expansion-panel__header {\n    background-color: #f2f2f2;\n}\n.expansion-panel {\n    box-shadow: none;\n}\n", ""]);

// exports
